var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakelivesend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    height: 32,
    width: 32,
    "_ngcontent-afe-c75": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "_ngcontent-afe-c75": "",
    width: 32,
    height: 32,
    rx: 16,
    fill: "#007094"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-afe-c75": "",
    d: "M12.5498 11.7401L18.9173 9.61762C21.7748 8.66512 23.3273 10.2251 22.3823 13.0826L20.2598 19.4501C18.8348 23.7326 16.4948 23.7326 15.0698 19.4501L14.4398 17.5601L12.5498 16.9301C8.26727 15.5051 8.26727 13.1726 12.5498 11.7401Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-afe-c75": "",
    d: "M14.582 17.2374L17.267 14.5449",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakelivesend);
export default __webpack_public_path__ + "static/media/makelivesend.b4fe9384e1a52902d24cf1bb6b543136.svg";
export { ForwardRef as ReactComponent };